import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/abonnementer")({
	beforeLoad: () => {
		throw redirect({ to: "/account/admin/abonnementer" });
	},
});
